import React, { Fragment, useState } from "react";
import {
	Button,
	Confirm,
	useNotify,
	useRefresh,
	useUnselectAll,
	useUpdateMany,
} from "react-admin";

const SyncStatusButton = ({
	selectedIds,
	status = "none",
	label = "resources.bookmakers.buttons.sync_status.reset.label",
	confirmTitle = "resources.bookmakers.buttons.sync_status.reset.confirm_title",
	confirmContent = "resources.bookmakers.buttons.sync_status.reset.confirm_content",
	icon: Icon = null,
}) => {
	const [open, setOpen] = useState(false);
	const refresh = useRefresh();
	const notify = useNotify();
	const unselectAll = useUnselectAll();
	const [updateMany, { loading }] = useUpdateMany(
		"bookmakers",
		selectedIds,
		{ sync_status: status },
		{
			onSuccess: () => {
				refresh();
				notify("resources.bookmakers.buttons.sync_status.success");
				unselectAll("bookmakers");
			},
			onFailure: (error) =>
				notify("Error: bookmakers not updated", { type: "warning" }),
		}
	);
	const handleClick = () => setOpen(true);
	const handleDialogClose = () => setOpen(false);

	const handleConfirm = () => {
		updateMany();
		setOpen(false);
	};

	if (!selectedIds || selectedIds.length === 0) return null;

	return (
		<Fragment>
			<Button label={label} onClick={handleClick}>
				{Icon && <Icon />}
			</Button>
			<Confirm
				isOpen={open}
				loading={loading}
				title={confirmTitle}
				content={confirmContent}
				onConfirm={handleConfirm}
				onClose={handleDialogClose}
			/>
		</Fragment>
	);
};

export default SyncStatusButton;
